import { StepVariables } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

import {
    TOOL_REGISTRATION_CONTEXT,
    TOOL_REGISTRATION_STEPS
} from "@/services/tracking/trackers/tools/registration/config";
import * as ToolsStepTracker from "@/services/tracking/trackers/tools/toolStep.tracker";
import { createUserId } from "@/services/tracking/trackers/utils";

export const trackStart = () => {
    ToolsStepTracker.track(
        TOOL_REGISTRATION_STEPS.start,
        TOOL_REGISTRATION_CONTEXT
    );
};

export const trackSubmit = (registrationResult: any) => {
    if (!registrationResult) return;

    const customerId = createUserId(registrationResult.email);
    const step: StepVariables = {
        ...TOOL_REGISTRATION_STEPS.submit,
        result: {
            customerid: customerId,
            newsletteroptin: registrationResult.newsLetterSubscribed
        }
    };

    ToolsStepTracker.trackSubmit(step, TOOL_REGISTRATION_CONTEXT);
};
